<template>
  <div class="page-container">
    <div class="query-title">客户关系配置</div>

    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="客户编码" label-width="100px">
                    <el-input v-model="form.customer" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="客户名称" label-width="100px">
                    <el-input v-model="form.cust_name" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="老要货账号" label-width="100px">
                    <el-input v-model="form.l_customer" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="老要货账号名称" label-width="100px">
                    <el-input v-model="form.l_cust_name" />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="字典数据"
          :custome-config="() => vxeShowCustom('xTable')"
        >
          <template #button>
            <table-button name="add" tip="新增" @click="addDictRows" />
            <table-button name="export" tip="修改" @click="editDictRows" />
            <table-button name="export" tip="删除" @click="deleteRows" />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          />
        </TableCommon>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <Correspondence v-if="dialogVisible" ref="DictEdit" :mode="mode" :edit-rows="editRows" />
      <div slot="footer">
        <el-button size="small" type="default" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Correspondence from './components/Correspondence'
import { apiCrmMaintenance } from '@/api/sap/client-sap'
export default {
  components: { Correspondence },
  data() {
    return {
      form: {
        customer: '',
        cust_name: '',
        l_customer: '',
        l_cust_name: '',
      },
      mode: 'add',
      dialogVisible: false,
      editRows: [],
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 },
          { title: '新CRM账号', field: 'customer' },
          { title: '新CRM账号名称', field: 'cust_name' },
          { title: '老要货账号', field: 'l_customer' },
          { title: '老要货账号名称', field: 'l_cust_name' }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['customerInfo']),
    dialogTitle() {
      return this.mode === 'add' ? '新增' : '编辑'
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.editRows = []
      }
    }
  },
  methods: {
    async queryData() {
      const params = {
        mode: 'SELECT',
        user_bp: this.customerInfo.info.partner
      }
      if(this.form.customer){
        params.customer = [{
          "sign": "I",
          "option": "EQ",
          "low": this.form.customer,
          "high": ""
        }]
      }
      if(this.form.cust_name){
        params.cust_name = [{
          "sign": "I",
          "option": "EQ",
          "low": this.form.cust_name,
          "high": ""
        }]
      }
      if(this.form.l_customer){
        params.l_customer = [{
          "sign": "I",
          "option": "EQ",
          "low": this.form.l_customer,
          "high": ""
        }]
      }
      if(this.form.l_cust_name){
        params.l_cust_name = [{
          "sign": "I",
          "option": "EQ",
          "low": this.form.l_cust_name,
          "high": ""
        }]
      }
      const { data } = await apiCrmMaintenance(params)
      this.gridOptions.data = data
    },
    async submitHandle() {
      const data = this.$refs['DictEdit'].validRows()
      if (data) {
        const params = {
          mode: this.mode === 'add' ? 'INSERT' : 'UPDATE',
          user_bp: this.customerInfo.info.partner,
          data
        }
        const { msgtype, message } = await apiCrmMaintenance(params)
        if (msgtype === 'S') {
          this.$message.success(message)
          this.dialogVisible = false
          this.queryData()
          return
        }
        this.$message.error(message)
      }
    },
    reset() {
      this.form = {
        customer: '',
        cust_name: ''
      }
    },
    async deleteRows() {
      const data = this.$refs['xTable'].getCheckboxRecords()
      if (!data.length) {
        return this.$message.warning('请选择要删除的数据！')
      }
      const params = {
        mode: 'DELETE',
        user_bp: this.customerInfo.info.partner,
        data
      }
      const { msgtype, message } = await apiCrmMaintenance(params)
      if (msgtype === 'S') {
        this.$message.success(message)
        this.queryData()
      } else {
        this.$message.error(message)
      }
    },
    editDictRows() {
      const data = this.$refs['xTable'].getCheckboxRecords()
      if (!data.length) {
        return this.$message.warning('请选择要修改的数据！')
      }
      this.editRows = data
      this.mode = 'edit'
      this.dialogVisible = true
    },
    addDictRows() {
      this.mode = 'add'
      this.dialogVisible = true
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/correspondenceSetting.vue